export default "__VITE_ASSET__6c2f7472__"